import ContentProviderEndpoint from '../../../Content/ContentProviderEndpoint';
import { Observable, ReplaySubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { OpaCongressionalOutreach } from '../../../Kentico/DigitalDesign/opa_congressional_outreach';
import { OpaCongressionalOutreachEnriched } from './Models/OpaCongressionalOutreachEnriched';

export default class CongressionalOutreachSubpageProxy {
  digitalDesignContent: ContentProviderEndpoint;
  congressionalOutreachEnrichedSubject: Map<string, ReplaySubject<OpaCongressionalOutreachEnriched>>;
  congressionalOutreachSubject: ReplaySubject<OpaCongressionalOutreach[]>;
  congressionalOutreachSubjectWasCalled: boolean;

  constructor(digitalDesignContent: ContentProviderEndpoint) {
    this.digitalDesignContent = digitalDesignContent;
    this.congressionalOutreachEnrichedSubject = new Map<string, ReplaySubject<OpaCongressionalOutreachEnriched>>();
    this.congressionalOutreachSubject = new ReplaySubject<OpaCongressionalOutreach[]>();
    this.congressionalOutreachSubjectWasCalled = false;
  }

  getOutreachSubpage(urlSlug: string): Observable<OpaCongressionalOutreachEnriched> {
    const subject = this.congressionalOutreachEnrichedSubject.get(urlSlug);
    if (!subject) {
      const newSubject = new ReplaySubject<OpaCongressionalOutreachEnriched>(1);
      this.congressionalOutreachEnrichedSubject.set(urlSlug, newSubject);
      this.digitalDesignContent
        .items<OpaCongressionalOutreachEnriched>()
        .type('opa_congressional_outreach')
        .equalsFilter('elements.url_slug', urlSlug)
        .orderByDescending('elements.baseDatepublished')
        .limitParameter(1)
        .includeTotalCountParameter()
        .toObservable()
        .pipe(
          map((response) => {
            if (response.pagination.totalCount && response.pagination.totalCount > 1) {
              throw new Error('More than one item found');
            }
            if (response.items.length !== 1) {
              throw new Error('Expected exactly one item but found ' + response.items.length);
            }
            const article = response.items[0];
            article.linkedItems = response.linkedItems;

            return article;
          })
        )
        .subscribe(newSubject);
      return newSubject;
    } else {
      return subject;
    }
  }

  getOutreachSubpageImages(): Observable<OpaCongressionalOutreach[]> {
    if (!this.congressionalOutreachSubjectWasCalled) {
      this.congressionalOutreachSubjectWasCalled = true;
      this.digitalDesignContent
        .items<OpaCongressionalOutreach>()
        .type('opa_congressional_outreach')
        .orderByDescending('elements.baseDatepublished')
        .toObservable()
        .pipe(map((x) => x.items))
        .subscribe(this.congressionalOutreachSubject);
    }
    return this.congressionalOutreachSubject;
  }
}
